import * as type from "./types";
import { createReducer } from "../../../util/index";

const initialState = {
    // data: [],
};

const eventQNASettingReducer = createReducer(initialState) ({
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.payload
    }),

    [type.SETTING_DATA]: (state, action) => ({
        ...state,
        setting_data: action.payload
    }),

    [type.CREATE]: (state, action) => ({
        ...state,
        create: action.payload,
    }),

    [type.UPDATE]: (state, action) => ({
        ...state,
        update: action.payload
    })
});

export default eventQNASettingReducer;